import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "./components/pageNotFound/PageNotFound";
import Home from "./pages/home/Home";
import TopNavbar from "./components/topNavbar/TopNavbar";
import SecondTopNavbar from "./components/secondTopNavbar/SecondTopNavbar";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import About from "./pages/about/About";
import Schemes from "./pages/schemes/Schemes";
import GtpMembers from "./pages/gptMembers/GptMembers";
import ImportantPlaces from "./pages/importantPlaces/ImportantPlaces";
import SocialWorks from "./pages/socialWorks/SocialWorks";
import EmergencyContact from "./pages/emergencyContact/EmergencyContact";
import Contact from "./pages/contact/Contact";
import { DashboardDataProvider } from "./context/dashboardDataContext/DashboardDataContext";
import DataNotFound from "./components/dataNotFound/DataNotFound";
import ImageGallery from "./components/imageGallery/ImageGallery";
import ImageVideoGallery from "./components/imageGallery/ImageVideoGallery";
import PartnerLogoSlider from "./components/PartnerLogoSlider/PartnerLogoSlider";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop.jsx";

const App = () => {
  return (
    <HelmetProvider>
      <DashboardDataProvider>
        <div>
          <TopNavbar />
          <SecondTopNavbar />
          <Navbar />
          <ScrollToTop/>
          {/* <Bar /> */}
          <Routes>
            <Route path="/*" element={<PageNotFound />} />
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/schemes" element={<Schemes />} />
            <Route path="/gpt_members" element={<GtpMembers />} />
            <Route path="/imp-places" element={<ImportantPlaces />} />
            <Route path="/social-works" element={<SocialWorks />} />
            <Route path="/emergency-contact" element={<EmergencyContact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/img_gallery" element={<ImageGallery />} />
            <Route path="/img_video_gallery" element={<ImageVideoGallery />} />
            <Route path="/partner_slider" element={<PartnerLogoSlider />} />
            <Route path="/data_not_found" element={<DataNotFound />} />
          </Routes>
          <Footer />
        </div>
      </DashboardDataProvider>
    </HelmetProvider>
  );
};

export default App;
